import { Suspense } from 'react';
import { Outlet } from 'react-router';
import { Spinner } from '@/components/ui/Spinner';
import { MobileHeader, MobileTabBar } from './MobileChrome';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';

/** Responsive shell: sidebar + top bar on PC (and landscape tablets), header + tab bar on phones. */
export function AppShell() {
  return (
    <div className="min-h-dvh lg:grid lg:grid-cols-[288px_minmax(0,1fr)] print:block">
      <Sidebar />
      <div className="flex min-w-0 flex-col">
        <TopBar />
        <MobileHeader />
        <main
          id="main"
          className="w-full max-w-[1600px] flex-1 px-4 pt-5 pb-32 sm:px-6 lg:px-10 lg:pt-8 lg:pb-14 print:p-0"
        >
          <Suspense
            fallback={
              <div className="flex justify-center py-24 text-primary">
                <Spinner className="size-7" />
              </div>
            }
          >
            <Outlet />
          </Suspense>
        </main>
      </div>
      <MobileTabBar />
    </div>
  );
}
